/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamLogoResource
 */
export interface TeamLogoResource {
    /**
     * 
     * @type {string}
     * @memberof TeamLogoResource
     */
    absoluteUrl: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLogoResource
     */
    baseUrl: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLogoResource
     */
    fileName: string;
}

/**
 * Check if a given object implements the TeamLogoResource interface.
 */
export function instanceOfTeamLogoResource(value: object): value is TeamLogoResource {
    if (!('absoluteUrl' in value) || value['absoluteUrl'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function TeamLogoResourceFromJSON(json: any): TeamLogoResource {
    return TeamLogoResourceFromJSONTyped(json, false);
}

export function TeamLogoResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLogoResource {
    if (json == null) {
        return json;
    }
    return {
        
        'absoluteUrl': json['absoluteUrl'],
        'baseUrl': json['baseUrl'],
        'fileName': json['fileName'],
    };
}

export function TeamLogoResourceToJSON(value?: TeamLogoResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'absoluteUrl': value['absoluteUrl'],
        'baseUrl': value['baseUrl'],
        'fileName': value['fileName'],
    };
}

